import type { DesignDefinition } from '../types';

const spring = { type: 'spring', bounce: 0.38 } as const;

/** F · Storybook: springy, a little playful, like stickers being placed on a page. */
export const storybook: DesignDefinition = {
  id: 'storybook',
  name: 'Storybook',
  nameZh: '绘本',
  description: 'Warm paper, doodles and my cartoon self',
  descriptionZh: '暖色纸张、手绘涂鸦和卡通的我',
  swatches: ['#2A5BD7', '#F0563A', '#F6B92B'],
  preview: { canvas: '#FBF5EA', ink: '#1E2235', font: 'var(--font-young-serif), Georgia, serif' },
  motion: {
    reveal: { transition: { ...spring, duration: 0.9 }, tilt: -1.5 },
    heading: { duration: 1, ease: [0.22, 1, 0.36, 1] },
    clip: { ...spring, duration: 1 },
    stagger: 0.08,
    hover: { y: -6, rotate: -0.8, transition: { type: 'spring', stiffness: 320, damping: 16 } },
    float: { y: -10, duration: 5 },
    layout: { type: 'spring', stiffness: 420, damping: 26 },
  },
};
